import { useState } from 'react';

import { Box, Text, Icon, Flex, IconButton } from '@chakra-ui/react';

import { LikePisteIcon, DislikePisteIcon } from '@inspire/ui/icons';
import { useMyProfile, useRateAlgoResult } from 'lib/hooks';

interface PisteFeedbackForSinglePisteProps {
  pisteId: string;
}

const PisteFeedbackForSinglePiste = ({
  pisteId,
}: PisteFeedbackForSinglePisteProps) => {
  const { myProfile, isMyProfileLoading } = useMyProfile();

  const [likeSelected, setLikeSelected] = useState(undefined);
  const [dislikeSelected, setDislikeSelected] = useState(undefined);

  if (
    !isMyProfileLoading &&
    likeSelected === undefined &&
    dislikeSelected === undefined
  ) {
    const pisteRating = myProfile.algoResults?.find(
      (ar) => ar.pisteId === pisteId
    ).rating;

    setLikeSelected(pisteRating === 2);
    setDislikeSelected(pisteRating === -2);
  }

  const { rateAlgoResult } = useRateAlgoResult(pisteId);

  const noneSelected = !likeSelected && !dislikeSelected;

  return (
    <Box
      bgColor="rgba(0,0,0, 0.5)"
      maxW="200px"
      borderRadius={4}
      pb={5}
      color="white"
    >
      <Text textAlign="center">Es-tu d'accord avec cette recommandation ?</Text>
      <Flex justifyContent={'space-evenly'}>
        <IconButton
          size="lg"
          aria-label="Oui"
          icon={<Icon as={LikePisteIcon} boxSize={7} />}
          variant={noneSelected || likeSelected ? undefined : 'ghost'}
          onClick={() => {
            rateAlgoResult(2);
            setLikeSelected(true);
            setDislikeSelected(false);
          }}
          color={
            likeSelected
              ? 'black'
              : dislikeSelected
              ? 'white'
              : 'blackAlpha.500'
          }
        />
        <IconButton
          size="lg"
          aria-label="Oui"
          icon={<Icon as={DislikePisteIcon} boxSize={7} />}
          variant={noneSelected || dislikeSelected ? undefined : 'ghost'}
          onClick={() => {
            rateAlgoResult(-2);
            setDislikeSelected(true);
            setLikeSelected(false);
          }}
          color={
            dislikeSelected
              ? 'black'
              : likeSelected
              ? 'white'
              : 'blackAlpha.500'
          }
        />
      </Flex>
    </Box>
  );
};

export default PisteFeedbackForSinglePiste;
